export default "__VITE_ASSET__771d19f2__"